jQuery(document).ready(function ($) {

  function initMobileSliders() {

    // Shop Category Slider
    if ($(window).width() <= 749) {

      if (
        $('.shop_category_items').length &&
        !$('.shop_category_items').hasClass('slick-initialized')
      ) {
        $('.shop_category_items').slick({
          dots: true,
          arrows: false,
          appendDots: $('.shop_category_items')
            .closest('section')
            .find('.custom_dots'),
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false
        });
      }

      // Featured Products Slider
      if (
        $('.featured_products_grid').length &&
        !$('.featured_products_grid').hasClass('slick-initialized')
      ) {
        $('.featured_products_grid').slick({
          dots: true,
          arrows: false,
          appendDots: $('.featured_products_grid')
            .closest('section')
            .find('.custom_dots'),
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false
        });
      }

    } else {

      // Destroy Shop Category Slider
      if ($('.shop_category_items').hasClass('slick-initialized')) {
        $('.shop_category_items').slick('unslick');
      }

      // Destroy Featured Products Slider
      if ($('.featured_products_grid').hasClass('slick-initialized')) {
        $('.featured_products_grid').slick('unslick');
      }
    }
  }

  initMobileSliders();

  $(window).on('resize', function () {
    initMobileSliders();
  });

});

 
 



(() => {
  // 1. Inject CSS for smooth transition styling and arrow rotation
  const style = document.createElement('style');
  style.textContent = `
    .bold_option_title {
      cursor: pointer;
      user-select: none;
      display: flex;
      align-items: flex-start;
      justify-content: space-between; /* Pushes the text left and arrow right */
      padding: 10px 0;
      width: 100%;
    }
    
    /* Rotate the arrow icon smoothly when open */
    .bold_option_set.is-open-set .icon--arrow-bottom {
      transform: rotate(180deg);
    }
    
    .icon--arrow-bottom {
      transition: transform 0.3s ease-in-out;
      margin-left: 10px;
    }
    
    /* Dropdown elements animation */
    .bold_option_element {
      max-height: 0;
      overflow: hidden;
      opacity: 0;
      transition: max-height 0.35s ease-in-out, opacity 0.25s ease-in-out;
    }
    
    .bold_option_element.is-open {
      max-height: 1200px; 
      opacity: 1;
    }

    /* Active swatch border/styling fallback - adjust styling as needed */
    .bold_option_value.is-active .bold_option_value_element {
    border: 1px solid #0a142f42 !important;
    box-shadow: 0 0 5px rgba(111, 66, 239, 0.5);
    border-radius: 5px !important;
}
  `;
  document.head.appendChild(style);

  // 2. Main Accordion Logic
  const initAccordion = () => {
    const optionSets = document.querySelectorAll(".bold_option_set");

    optionSets.forEach((set) => {
      const title = set.querySelector(".bold_option_title");
      const element = set.querySelector(".bold_option_element");

      if (!title || !element) return;

      // Prevent attaching duplicate events and appending duplicate icons if script reruns
      if (title.dataset.accordionBound) return;
      title.dataset.accordionBound = "true";

      // Insert your exact SVG icon into the title string
      title.innerHTML += `
        <svg class="icon icon--arrow-bottom" width="10" height="4" viewBox="0 0 10 4" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.76318 3.75L9.52632 0H4.3869e-05L4.76318 3.75Z" fill="#6F42EF"></path>
        </svg>
      `;

      title.addEventListener("click", () => {
        const isOpen = element.classList.contains("is-open");

        // Close all other elements and remove open state classes
        optionSets.forEach((otherSet) => {
          const otherElement = otherSet.querySelector(".bold_option_element");
          if (otherElement) {
            otherElement.classList.remove("is-open");
          }
          otherSet.classList.remove("is-open-set");
        });

        // Toggle this current item
        if (!isOpen) {
          element.classList.add("is-open");
          set.classList.add("is-open-set"); // This handles rotating this specific arrow
        }
      });

      // ----------------------------------------------------
      // NEW: Swatch Logic Integration for "Single Selection"
      // ----------------------------------------------------
      if (element.dataset.swatchBound) return;
      element.dataset.swatchBound = "true";

      element.addEventListener('click', function(e) {
        // Find the wrapper block for the option clicked
        const clickedOption = e.target.closest('.bold_option_value');
        if (!clickedOption) return;

        // Prevent double default fires from custom label setups
        e.preventDefault();

        const allOptions = element.querySelectorAll('.bold_option_value');

        allOptions.forEach(option => {
          const checkbox = option.querySelector('input[type="checkbox"]');
          const visualElement = option.querySelector('.bold_option_value_element');

          if (option === clickedOption) {
            // Select this item
            option.classList.add('is-active');
            if (visualElement) {
              visualElement.setAttribute('aria-checked', 'true');
              visualElement.classList.add('selected'); 
            }
            if (checkbox && !checkbox.checked) {
              checkbox.checked = true;
              // Tells Bold Product Options & Warehouse Theme that value changed
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            // Deselect all others
            option.classList.remove('is-active');
            if (visualElement) {
              visualElement.setAttribute('aria-checked', 'false');
              visualElement.classList.remove('selected');
            }
            if (checkbox && checkbox.checked) {
              checkbox.checked = false;
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });
      });
    });
  };

  // 3. MutationObserver to handle Shopify Warehouse / Bold app dynamic loading
  const observer = new MutationObserver((mutations, obs) => {
    if (document.querySelector(".bold_options_loaded")) {
      initAccordion();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();



$('.product-gallery__thumbnail-list').slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  variableWidth: true,
  arrows: true,
  dots: false,
  infinite: false,
  speed: 300,
  prevArrow: `
        <button type="button" class="slick-prev">
          &#10094;
        </button>
      `,

      nextArrow: `
        <button type="button" class="slick-next">
          &#10095;
        </button>
      `,

  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 4
      }
    }
  ]
});




